import type { UserCredential } from 'firebase/auth';
import { firebaseAuthService } from '@/core/services';

export class LoginComGoogleUseCase {
  async execute(): Promise<UserCredential> {
    return firebaseAuthService.signInWithGoogle();
  }
}
